let info = {
  name: "Emre Bayazitoglu",
  logo_name: "emre",
  flat_picture: require("./src/assets/potrait2.jpg"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false
    }
  },
  description:
    "My name is Emre, and I am a computer science graduate at the Albert Ludwig University of Freiburg.<br><br>" +
    "During my studies, I worked in a company as a working student in software engineering for 2 years. Currently, I am employed as a full-time and full-stack software engineer.",
  links: {
    linkedin: "https://www.linkedin.com/in/emre-bayazitoglu/",
    github: "https://github.com/Emredinho61",
    leetcode: "https://leetcode.com/Emredinho61/",
    // TODO: change resume
    resume:
      ""
  },
  education: [
    {
      name: "Carl-Helbing-Schule",
      place: "Emmendingen",
      date: "Sept. 2018 - Aug. 2020",
      degree: "Business High School Graduation",
      gpa: "1.6 / 6",
      description:
        "Highschool with focus on business and commercial studies.",
      skills: [
        "Microsoft Office", "MySQL", "Java", "Greenfoot", "HTML & CSS"
      ]
    },
    {
      name: "Albert Ludwig University of Freiburg",
      place: "Freiburg",
      date: "Oct. 2020 - Dec. 2024",
      degree: "Bachelor of Science: Computer Science",
      description:
        "Graduation from the Albert-Ludwigs University of Freiburg with a Bachelor of Science in Computer Science.",
      skills: [
        "Python", "Java", "C", "C#", "Bash", "Linux", "AI", "Embedded Systems"
      ]
    }
  ],
  experience: [
    {
      name: "FRAKO Kondensatoren- und Anlagenbau GmbH",
      place: "Teningen",
      date: "Dec. 2022 - Jan. 2025",
      position: "Working Student, App Development",
      description:
        "Worked in the development department as a webapp developer alonside my studies.",
      skills: ["VueJs", "DevOps", "Python", "Flask", "Javascript", "MSSQL", "Linux based OS'", "Bash"]
    },
    {
      name: "ZAHORANSKY AG",
      place: "Todtnau/Freiburg",
      date: "Mar. 2025 - present",
      position: "Full-Stack Software Engineering",
      description:
        "Data Science, ",
      skills: ["Python", "VueJs", "FastAPI", "InfluxDBv2", "Javascript", "Docker", "Linux based OS'", "Bash", "Cyber Security", "etc."]
    }
  ],
  skills: [
    {
      title: "languages",
      info: [
        "Python",
        "Javascript",
        "Java",
        "Rust",
        "C",
        "C#",
        "SQL",
        "Bash",
        "Dart"
      ],
      icon: "fa fa-code"
    },
    {
      title: "frameworks and tools",
      info: [
        "Flask",
        "Numpy",
        "Pandas",
        "SciPy",
        "peersim",
        "matplotlib",
        "sqllite3",
        "Flutter",
        "etc."
      ],
      icon: "fa fa-cubes"
    },
    {
      title: "web technologies",
      info: ["VueJs", "React", "HTML", "CSS"],
      icon: "fas fa-laptop-code"
    },
    {
      title: "databases",
      info: ["MySQL", "MSSQL", "InfluxDB", "PostgreSQL"],
      icon: "fa fa-database"
    },
    {
      title: "operating systems",
      info: [
        "Ubuntu",
        "Fedora",
        "Arch",
        "Windows",
        "Android",
      ],
      icon: "fas fa-tools"
    },
  ],
  portfolio: [
    {
      name: "Bachelor Thesis",
      pictures: [
        {
          img: require("./src/assets/portfolio/thesis/p2p.jpg")
        },
      ],
      technologies: ["Python", "Java", "peersim", "matplotlib", "scipy", "numpy", "Bash", "Data Analysis"],
      category: "simulations in P2P networks / document",
      date: "Dec. 2024 - Feb. 2025",
      github:
        "https://github.com/Emredinho61/bachelor-thesis",
      visit: "https://github.com/Emredinho61/bachelor-thesis",
      description:
        "Simulations in Peer-to-Peer networks using Java and a simulation framwork peersim. The goal was to design a load balancing algorithm, based on two well-established algorithms for further improvements in network balancing. More can be read in the thesis document which is also available on my Github."
    },
    {
      name: "NBA Shooting Map Plotter",
      pictures: [
        {
          img: require("./src/assets/portfolio/msr/logo.png")
        },
        {
          img: require("./src/assets/portfolio/msr/preview.png")
        },
        {
          img: require("./src/assets/portfolio/msr/imagezoomed.png")
        },
      ],
      technologies: ["Python", "Flask", "VueJs", "matplotlib", "axios", "PrimeVue", "Docker and Docker-Compose", "Data Analysis"],
      category: "web app for visualization",
      date: "Mar. 2024",
      github:
        "https://github.com/Emredinho61/matplotlib_nba_shootingmap_function_plotter",
      visit: "https://github.com/Emredinho61/matplotlib_nba_shootingmap_function_plotter",
      description:
        "This is a project that generates a shooting heatmap depending on user input. The user can select seasons between 2004 and 2022, then select the player per team and decide whether he wants to have the shots made or missed as a marking map or as a heat map. This software is not hosted yet, but can easily setup up, since docker configurations are provided for front and backend."
    },
    {
      name: "Load Balancing Algorithms",
      pictures: [
        {
          img: require("./src/assets/portfolio/noq/logo.png")
        }
      ],
      technologies: ["Java", "Peersim", "VueJs", "LaTex", "Plotting", "P2P Networks", "Graph Theory", "Computer Networking"],
      category: "Simulation",
      date: "Jan. 2024 - Jun. 2024",
      description:
        "Comparative analyses of different load balancing algorithms in different network types are carried out. The results are then plotted in an comprehensive plots."
    },
    {
      name: "Plotter",
      pictures: [
        {
          img: require("./src/assets/portfolio/post/image.png")
        },
        {
          img: require("./src/assets/portfolio/post/image-1.png")
        },
        {
          img: require("./src/assets/portfolio/post/image-2.png")
        },
        {
          img: require("./src/assets/portfolio/post/image-3.png")
        },
      ],
      technologies: [
        "VueJs", "Python", "Flask", "matplotlib", "numpy", "Docker and Docker-Compose", "pandas"
      ],
      category: "web app with plotting scripts",
      github: "https://github.com/Emredinho61/matplotlib_nba_shootingmap_function_plotter",
      date: "Mar. 2024",
      visit: "https://github.com/Emredinho61/matplotlib_nba_shootingmap_function_plotter",
      description:
        "In this project, an attempt was made to make various mathematical plots generatable for the user in the simplest possible way. A web app with VueJs accepts user input. These user inputs are processed and resulting to a nice plot. You can plot pie charts, simple functions (incl. sine, cosine and tangent) and bar charts."
    }, 
    {
      name: "Prayer Times App",
      pictures: [
        {
          img: require("./src/assets/portfolio/flutter/logo.jpg")
        },
      ],
      technologies: ["Flutter", "Firebase", "Firestore", "Dart", "Cloud Messaging"],
      category: "App",
      date: "Sept. 2025 - present",
      description:
        "Feature-rich Prayer Times App tailored for the requirements of my local mosque."
    },
    {
      name: "Commando Islands",
      pictures: [
        {
          img: require("./src/assets/portfolio/ci/image1.png")
        },
        {
          img: require("./src/assets/portfolio/ci/image2.png")
        },
        {
          img: require("./src/assets/portfolio/ci/image3.png")
        },
        {
          img: require("./src/assets/portfolio/ci/image4.png")
        }
      ],
      technologies: [".NET Core 6.0", "C#", "MonoGame", "JetBrains ReSharper", "Tiled", "Newtonsoft Serializer"],
      category: "Game",
      date: "Oct. 2022 - Mar. 2023",
      description:
        "This is a game that was created in a group project as part of an event at the university. The aim was to create a game that fulfils several requirements and to learn programming in SCRUM in the process. The final grade was a 1.3/5.0"
    },
    {
      name: "C Projects",
      pictures: [
        {
          img: require("./src/assets/portfolio/clang/logo.jpg")
        },
      ],
      technologies: ["C", "vim"],
      category: "Games and Tools",
      date: "Apr. 2021 - Sept. 2021",
      description:
        "Multiple C projects have been programmed, including: a spaceship game, a wave plotter, minesweeper, Conway's Game of Life, etc."
    },
  ],
  portfolio_design: [
    
    {
      name: "Stay tuned for feature blogposts",
      title: "sample - blogposts",
      pictures: [
        {
          img: require("./src/assets/designs/sampleblog/coming-soon.jpg"),
          title: "Stay Tuned"
        },
      ],
      technologies: ["Tag1", "Tag2"],
      category: "x min read",
      github: "",
      date: "26th March, 2024",
      visit: "",
      description:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. <br> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. <br> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet."
    }
  ],
  recommendations: [
    {
      description: "hello",
      title:
        "Lorem Ipsum.",
      author: "Lorem Ipsum",
      position: "Lorem Ipsum",
      company: "ASDafdsdfa",
      location: "Berlin"
    },

  ]
};

export default info;
